import React from 'react';

interface PriceEntryProps {
  cadence?: string // cadence is not available in legacy plans
  price: string
  nextBillDay: string
}
const PriceEntry: React.FC<PriceEntryProps> = ({ cadence, price, nextBillDay }) => (
  <>
    <strong>{price}</strong>
    {' / month '}
    <span className="text-gray-600">
      {`(${cadence ? `${cadence} ` : ''}Billing - ${nextBillDay})`}
    </span>
  </>
);
export { PriceEntry };
